(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.transparent = this.hasAttribute("data-transparent");
      this.sticky = this.hasAttribute("data-sticky");
      this.selectors = {
        announcementBar: ".shopify-section-announcement-bar",
      };
      this.announcementBarheight = 0;
      this.prevScrollY = 0;

      this.transparent && document.body.classList.add('transparent-header');
    }

    connectedCallback() {
      ["scroll", "load", "resize"].forEach((event) =>
        window.addEventListener(event, (event) => {
          this.updateHeaderOffsetVariables();
          this.handleTransparent();
          this.checkOverflowSubmenus();
          if(this.transparent) this.offsetMainContent();
        })
      );

      if (this.hasAttribute('data-design-mode') && this.transparent) {
        window.addEventListener('shopify:section:load', (event) => {
          document.querySelector('#MainContent').style.marginTop = 0;

          // delay until styles are loaded
          setTimeout(() => {
            this.offsetMainContent();
          }, 1000);
          return;
        })
      }

      if (!this.transparent) return;
      this.offsetMainContent();
    }

    offsetMainContent() {
      document.querySelector(
        "#MainContent"
      ).style.marginTop = `-${this.offsetHeight  * 0.1}rem`;
    }

    handleTransparent() {
      const transparentAndSticky = this.transparent && this.sticky
      if (!transparentAndSticky) return;
      this.classList.toggle(
        "is-transparent",
        window.scrollY <= this.announcementBarHeight
      );

      this.classList.toggle(
        "is-scroll",
        window.scrollY > 50
      );
    }

    updateHeaderOffsetVariables() {
      const announcementBar = document.querySelector(
        this.selectors.announcementBar
      );
      this.announcementBarHeight = announcementBar
        ? announcementBar.offsetHeight
        : 0;
      const headerHeight = this.transparent ? 0 : this.offsetHeight;
      const headerOffset = this.announcementBarHeight + headerHeight;
      // Header height regardless of whether it's transparent or not.
      const transparentHeaderOffset = this.announcementBarHeight + this.offsetHeight;

      document.documentElement.style.setProperty(
        "--header-offset",
        `${headerOffset * 0.1}rem`
      );

      document.documentElement.style.setProperty(
        "--header-offset-with-transparent",
        `${transparentHeaderOffset * 0.1}rem`
      );

      const headerBottomPosition = this.getBoundingClientRect().bottom * 0.1;
      document.documentElement.style.setProperty(
        "--header-dropdown-max-height",
        `calc(100vmin - ${headerBottomPosition}rem)`
      );

      document.documentElement.style.setProperty(
        "--header-top-offset",
        `-${window.scrollY > 0 ? (window.scrollY > this.prevScrollY ? this.offsetHeight : 0) : 0}px`
      );

      document.documentElement.style.setProperty(
        "--header-logo-shrink",
        `${window.scrollY > this.prevScrollY ? 0.8 : 1}`
      );

      window.scrollY == 0 ? this.classList.remove('is-scroll') : this.classList.add('is-scroll');

      this.prevScrollY = window.scrollY;
    }

    checkOverflowSubmenus() {
      const containerBounderie =
        this.querySelector('[data-container]').getBoundingClientRect().width;

      this.querySelectorAll('[data-nav-sublinks]').forEach(submenu => {
        submenu.closest('[data-nav-dropdown]').classList.remove('is-overflowing');
        const [submenuLeft, submenuRight] = [
          submenu.getBoundingClientRect().left,
          submenu.getBoundingClientRect().right
        ];
        const submenuIsOverflowing =
          submenuLeft > containerBounderie || submenuRight > containerBounderie;
        if (submenuIsOverflowing) {
          submenu.closest('[data-nav-dropdown]')
            .classList.add('is-overflowing')
        }
      })
    }
  }

  customElements.define("sticky-header", StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
